export const tagPrintContentStyle = `
  .pt__app-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: "left right";
    gap: 0px;
    width: 100%;
    background: #FFFFFF;
    padding: 1rem 1.5rem;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 8px rgba(181, 185, 255, 0.4);
    border: 1px solid #E6E6E6;
  }
  .pt__app-container .pt__tag__left-info h4 {
    font-weight: 600;
    font-size: 20px;
    letter-spacing: 0.01em;
    line-height: 24px;
    color: var(--color-blue-dark);
  }
  .pt__app-container .pt__print-tag__barcode {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 0.5rem;
  }
  .pt__app-container .pt__button_print_tag {
    color: #FFFFFF;
    cursor: pointer;
    display: inline-block;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px; 
    background: linear-gradient(171.14deg, #002eff 3.14%, #002eff 20.68%, #002eff 103.69%);
    box-shadow: 0px 4px 8px rgba(181, 185, 255, 0.4);
    border-radius: 2rem;
    padding: 0.5rem 1.4rem;
  }
  .bt-invisible {
    border-top: none;
  }
  .br-invisible {
    border-right: none;
  }
  .bl-invisible {
    border-left: none;
  }
  .bb-invisible {
    border-bottom: none;
  }
  .box-invisible {
    border: none;
  }
`